module.exports = __webpack_public_path__ + "img/zyncro-icon.b957d3f3.svg";